import {makeAutoObservable} from 'mobx'


export default class  ModalStore {
    modals = [
        {
            name: 'InfoModal',
            visible: false,
            payload: {}
        },
    ]

    constructor() {
        makeAutoObservable(this)
    }

    toggleModal = (name, payload): void => {
        this.modals.forEach((modal) => {
            if (modal.name === name) {
                modal.payload = payload
                modal.visible = !modal.visible
            }
        })
    }

    openModal = (name, payload: object = {}) => {
        this.modals.forEach((modal) => {
            if (modal.name === name) {
                modal.payload = payload
                modal.visible = true
            }
        })
    }

    closeModal = (name) => {
        this.modals.forEach((modal) => {
            if (modal.name === name) {
                modal.payload = {}
                modal.visible = false
            }
        })
    }

    getModal = (name): void => {
        const modal = this.modals.find(item => item.name === name)
        return modal
    }
}


